<template>
  <div>
    <SearchCriteriaCondition
      :ref="searchCriteriaConditionKey"
      :fieldList="fieldList"
      @on-condition-item-add="addConditionItem"
    />
    <v-row
      justify="space-between"
      align="center"
      class="pa-1"
      style="padding-left: 25% !important; padding-right: 25% !important"
    >
      <v-btn
        small
        v-for="op in logicalOperators"
        :key="op.value"
        class="ma-2"
        dark
        outlined
        :color="op.color"
        @click="addOperator(op)"
        >{{ op.value }}</v-btn
      >
    </v-row>
    <v-row justify="start" align="center" class="mb-2">
      <v-col>
        <v-card outlined class="pa-3">
          <v-chip-group column>
            <draggable :list="conditionItems" draggable=".draggableItem">
              <v-chip
                v-for="conditionItem in conditionItems"
                :key="conditionItem.uuid"
                label
                close
                close-icon="mdi-close"
                class="draggableItem"
                :color="conditionItem.color"
                outlined
                @click:close="removeConditionItem(conditionItem)"
                >{{ conditionItem.displayText() }}</v-chip
              >
            </draggable>
          </v-chip-group>
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import SearchCriteriaCondition from "@/components/search/SearchCriteriaCondition.vue";
import SearchService from "@/services/SearchService";
import ConditionItem from "@/ecm/models/search/ConditionItem";
import SearchConstValues from "@/ecm/variables/SearchConstValues";
import Utils from "@/ecm/common/Utils.js";
import draggable from "vuedraggable";

export default {
  components: {
    draggable,
    SearchCriteriaCondition,
  },
  props: {
    contentTypeIDs: {
      type: Array,
      default: () => [],
    },
  },
  async created() {
    this.fieldList = await this.getFields();
  },
  data() {
    return {
      logicalOperators: [
        { value: "(", color: "blue-grey" },
        { value: "OR", color: "blue" },
        { value: "AND", color: "teal" },
        { value: ")", color: "blue-grey" },
      ],
      userCultureCode: this.$store.getters["account/user"].CultureCode,
      conditionItems: [],
      searchCriteriaConditionKey: "searchCriteriaConditionKey",
      fieldList: [],
    };
  },
  computed: {
    searchCriteriaConditionInstance() {
      return this.$refs[this.searchCriteriaConditionKey];
    },
  },
  watch: {
    contentTypeIDs: {
      immediate: true,
      async handler() {
        this.fieldList = await this.getFields();
      },
    },
  },
  methods: {
    async getFields() {
      var standardFields = this.$store.getters["account/searchStandardFields"];
      if (this.contentTypeIDs != "") {
        var fields = await SearchService.getAdvSearchFields(
          this.contentTypeIDs.join()
        );
        return [...fields, ...standardFields];
      } else {
        return standardFields;
      }
    },
    async edit(conditionStr) {
      this.conditionItems = [];
      if (conditionStr) {
        this.fieldList = await this.getFields();
        conditionStr.split(";").forEach((condition) => {
          var conditionItem = new ConditionItem(condition);
          this.setConditionItemDisplayValues(conditionItem);
          this.conditionItems.push(conditionItem);
        });
      }
    },
    reset() {
      this.conditionItems = [];
      this.searchCriteriaConditionInstance.reset();
    },
    setConditionItemDisplayValues(conditionItem) {
      var field = this.fieldList.find((x) => x.Code == conditionItem.fieldCode);
      if (field) {
        conditionItem.fieldTitle = field.Title;
      }
      var searchOperator = this.$store.getters["account/searchOperators"].find(
        (x) => x.Code == conditionItem.searchOperatorCode
      );
      if (searchOperator) {
        conditionItem.searchOperatorTitle = searchOperator.Title;
      }
      if (conditionItem.fieldValue == SearchConstValues.Today) {
        conditionItem.fieldDisplayValue = this.$t("Today");
      } else if (conditionItem.fieldValue == SearchConstValues.Myself) {
        conditionItem.fieldDisplayValue = this.$t("Myself");
      } else if (
        conditionItem.fieldValue == SearchConstValues.Empty ||
        conditionItem.fieldValue == SearchConstValues.NotEmpty
      ) {
        conditionItem.fieldValue = "";
      } else if (conditionItem.fieldDisplayValue == SearchConstValues.Myself) {
        conditionItem.fieldValue = this.$t("Myself");
      } else {
        conditionItem.fieldDisplayValue = conditionItem.fieldValue
          .replace(
            SearchConstValues.DaysBeforeToday,
            `${this.$t("DaysBeforeToday")} ${this.$t("Today")}`
          )
          .replace(
            SearchConstValues.DaysAfterToday,
            `${this.$t("DaysAfterToday")} ${this.$t("Today")}`
          );
      }
    },
    getConditionStr() {
      var conditionStr = "";
      if (this.conditionItems.length == 0) {
        this.searchCriteriaConditionInstance.onConditionItemAdd();
      }
      if (this.conditionItems.length > 0) {
        conditionStr = this.conditionItems
          .map((item) => item.conditionStr())
          .join(";");
      }
      if (this.validateCriteria(conditionStr)) {
        return conditionStr;
      } else {
        Utils.toast.error(this.$t("SearchCriteriaFormatException"));
        return "INVALID";
      }
    },
    getDisplayConditionStr(conditionStr) {
      var conditionItems = [];
      if (conditionStr) {
        conditionStr.split(";").forEach((condition) => {
          var conditionItem = new ConditionItem(condition);
          this.setConditionItemDisplayValues(conditionItem);
          conditionItems.push(conditionItem);
        });
      } else {
        conditionItems = this.conditionItems;
      }
      var displayConditionStr = "";
      if (conditionItems.length == 0) {
        this.searchCriteriaConditionInstance.onConditionItemAdd();
      }
      if (conditionItems.length > 0) {
        displayConditionStr = conditionItems
          .map((item) => item.displayText())
          .join(";");
      }
      if (displayConditionStr == "") {
        return;
      }
      return displayConditionStr;
    },
    removeConditionItem(item) {
      this.conditionItems = this.conditionItems.filter(
        (f) => f.uuid != item.uuid
      );
    },
    addOperator(operator) {
      var item = new ConditionItem();
      item.fieldValue = operator.value;
      item.isLogicalOperator = true;
      item.color = operator.color;
      this.conditionItems.push(item);
    },
    addConditionItem(conditionItem) {
      conditionItem.color = "blue darken-4";
      this.setConditionItemDisplayValues(conditionItem);
      this.conditionItems.push(conditionItem);
    },
    validateCriteria(conditionStr) {
      function checkForBalancedBracketing([...str]) {
        return (
          str.reduce((uptoPrevChar, thisChar) => {
            (thisChar === "(" && uptoPrevChar++) ||
              (thisChar === ")" && uptoPrevChar--);
            return uptoPrevChar;
          }, 0) === 0
        );
      }
      function checkOperatorsAndConditions(str) {
        var criterias = str.split(";").filter((s) => s != "(" && s != ")");

        var i;
        for (i = 0; i < criterias.length; i++) {
          var j = i + 1;
          if (criterias[i] === "AND" || criterias[i] === "OR") {
            if (
              j < criterias.length &&
              (criterias[j] === "AND" || criterias[j] === "OR")
            ) {
              //Contiguous Operators
              return false;
            }
          } else if (criterias[i].includes("|")) {
            if (j < criterias.length && criterias[j].includes("|")) {
              //Contiguous Criterias
              return false;
            }
          }
        }

        if (
          criterias[0] === "AND" ||
          criterias[0] === "OR" ||
          criterias[criterias.length - 1] === "AND" ||
          criterias[criterias.length - 1] === "OR"
        ) {
          //Conditions cannot start or end with an operator
          return false;
        }
        return true;
      }
      return (
        checkForBalancedBracketing(conditionStr) &&
        checkOperatorsAndConditions(conditionStr)
      );
    },
  },
};
</script>
